module.exports = __webpack_public_path__ + "img/hort.aa63911c.png";